"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e29) { throw _e29; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e30) { didErr = true; err = _e30; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var e = require("react"),
  t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function i(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e["default"] : e;
}
var n,
  s = {
    exports: {}
  };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
n = s, function () {
  var e = {}.hasOwnProperty;
  function t() {
    for (var i = [], n = 0; n < arguments.length; n++) {
      var s = arguments[n];
      if (s) {
        var r = _typeof(s);
        if ("string" === r || "number" === r) i.push(s);else if (Array.isArray(s)) {
          if (s.length) {
            var o = t.apply(null, s);
            o && i.push(o);
          }
        } else if ("object" === r) if (s.toString === Object.prototype.toString) for (var a in s) e.call(s, a) && s[a] && i.push(a);else i.push(s.toString());
      }
    }
    return i.join(" ");
  }
  n.exports ? (t["default"] = t, n.exports = t) : window.classNames = t;
}();
var r = i(s.exports),
  o = NaN,
  a = "[object Symbol]",
  u = /^\s+|\s+$/g,
  c = /^[-+]0x[0-9a-f]+$/i,
  h = /^0b[01]+$/i,
  l = /^0o[0-7]+$/i,
  f = parseInt,
  m = Object.prototype.toString;
function d(e) {
  var t = _typeof(e);
  return !!e && ("object" == t || "function" == t);
}
function p(e) {
  if ("number" == typeof e) return e;
  if (function (e) {
    return "symbol" == _typeof(e) || function (e) {
      return !!e && "object" == _typeof(e);
    }(e) && m.call(e) == a;
  }(e)) return o;
  if (d(e)) {
    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
    e = d(t) ? t + "" : t;
  }
  if ("string" != typeof e) return 0 === e ? e : +e;
  e = e.replace(u, "");
  var i = h.test(e);
  return i || l.test(e) ? f(e.slice(2), i ? 2 : 8) : c.test(e) ? o : +e;
}
var v = i(function (e, t, i) {
    return void 0 === i && (i = t, t = void 0), void 0 !== i && (i = (i = p(i)) == i ? i : 0), void 0 !== t && (t = (t = p(t)) == t ? t : 0), function (e, t, i) {
      return e == e && (void 0 !== i && (e = e <= i ? e : i), void 0 !== t && (e = e >= t ? e : t)), e;
    }(p(e), t, i);
  }),
  y = {
    exports: {}
  };
!function (e, i) {
  var n = "__lodash_hash_undefined__",
    s = 1,
    r = 2,
    o = 9007199254740991,
    a = "[object Arguments]",
    u = "[object Array]",
    c = "[object AsyncFunction]",
    h = "[object Boolean]",
    l = "[object Date]",
    f = "[object Error]",
    m = "[object Function]",
    d = "[object GeneratorFunction]",
    p = "[object Map]",
    v = "[object Number]",
    y = "[object Null]",
    b = "[object Object]",
    g = "[object Promise]",
    z = "[object Proxy]",
    w = "[object RegExp]",
    S = "[object Set]",
    _ = "[object String]",
    I = "[object Symbol]",
    x = "[object Undefined]",
    E = "[object WeakMap]",
    V = "[object ArrayBuffer]",
    j = "[object DataView]",
    L = /^\[object .+?Constructor\]$/,
    O = /^(?:0|[1-9]\d*)$/,
    D = {};
  D["[object Float32Array]"] = D["[object Float64Array]"] = D["[object Int8Array]"] = D["[object Int16Array]"] = D["[object Int32Array]"] = D["[object Uint8Array]"] = D["[object Uint8ClampedArray]"] = D["[object Uint16Array]"] = D["[object Uint32Array]"] = !0, D[a] = D[u] = D[V] = D[h] = D[j] = D[l] = D[f] = D[m] = D[p] = D[v] = D[b] = D[w] = D[S] = D[_] = D[E] = !1;
  var N = "object" == _typeof(t) && t && t.Object === Object && t,
    M = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
    P = N || M || Function("return this")(),
    A = i && !i.nodeType && i,
    C = A && e && !e.nodeType && e,
    T = C && C.exports === A,
    F = T && N.process,
    k = function () {
      try {
        return F && F.binding && F.binding("util");
      } catch (e) {}
    }(),
    R = k && k.isTypedArray;
  function H(e, t) {
    for (var i = -1, n = null == e ? 0 : e.length; ++i < n;) if (t(e[i], i, e)) return !0;
    return !1;
  }
  function $(e) {
    var t = -1,
      i = Array(e.size);
    return e.forEach(function (e, n) {
      i[++t] = [n, e];
    }), i;
  }
  function Y(e) {
    var t = -1,
      i = Array(e.size);
    return e.forEach(function (e) {
      i[++t] = e;
    }), i;
  }
  var B,
    W,
    G,
    U = Array.prototype,
    X = Function.prototype,
    J = Object.prototype,
    K = P["__core-js_shared__"],
    Z = X.toString,
    q = J.hasOwnProperty,
    Q = (B = /[^.]+$/.exec(K && K.keys && K.keys.IE_PROTO || "")) ? "Symbol(src)_1." + B : "",
    ee = J.toString,
    te = RegExp("^" + Z.call(q).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
    ie = T ? P.Buffer : void 0,
    ne = P.Symbol,
    se = P.Uint8Array,
    re = J.propertyIsEnumerable,
    oe = U.splice,
    ae = ne ? ne.toStringTag : void 0,
    ue = Object.getOwnPropertySymbols,
    ce = ie ? ie.isBuffer : void 0,
    he = (W = Object.keys, G = Object, function (e) {
      return W(G(e));
    }),
    le = ke(P, "DataView"),
    fe = ke(P, "Map"),
    me = ke(P, "Promise"),
    de = ke(P, "Set"),
    pe = ke(P, "WeakMap"),
    ve = ke(Object, "create"),
    ye = Ye(le),
    be = Ye(fe),
    ge = Ye(me),
    ze = Ye(de),
    we = Ye(pe),
    Se = ne ? ne.prototype : void 0,
    _e = Se ? Se.valueOf : void 0;
  function Ie(e) {
    var t = -1,
      i = null == e ? 0 : e.length;
    for (this.clear(); ++t < i;) {
      var n = e[t];
      this.set(n[0], n[1]);
    }
  }
  function xe(e) {
    var t = -1,
      i = null == e ? 0 : e.length;
    for (this.clear(); ++t < i;) {
      var n = e[t];
      this.set(n[0], n[1]);
    }
  }
  function Ee(e) {
    var t = -1,
      i = null == e ? 0 : e.length;
    for (this.clear(); ++t < i;) {
      var n = e[t];
      this.set(n[0], n[1]);
    }
  }
  function Ve(e) {
    var t = -1,
      i = null == e ? 0 : e.length;
    for (this.__data__ = new Ee(); ++t < i;) this.add(e[t]);
  }
  function je(e) {
    var t = this.__data__ = new xe(e);
    this.size = t.size;
  }
  function Le(e, t) {
    var i = Ge(e),
      n = !i && We(e),
      s = !i && !n && Ue(e),
      r = !i && !n && !s && qe(e),
      o = i || n || s || r,
      a = o ? function (e, t) {
        for (var i = -1, n = Array(e); ++i < e;) n[i] = t(i);
        return n;
      }(e.length, String) : [],
      u = a.length;
    for (var c in e) !t && !q.call(e, c) || o && ("length" == c || s && ("offset" == c || "parent" == c) || r && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || $e(c, u)) || a.push(c);
    return a;
  }
  function Oe(e, t) {
    for (var i = e.length; i--;) if (Be(e[i][0], t)) return i;
    return -1;
  }
  function De(e) {
    return null == e ? void 0 === e ? x : y : ae && ae in Object(e) ? function (e) {
      var t = q.call(e, ae),
        i = e[ae];
      try {
        e[ae] = void 0;
        var n = !0;
      } catch (e) {}
      var s = ee.call(e);
      n && (t ? e[ae] = i : delete e[ae]);
      return s;
    }(e) : function (e) {
      return ee.call(e);
    }(e);
  }
  function Ne(e) {
    return Ze(e) && De(e) == a;
  }
  function Me(e, t, i, n, o) {
    return e === t || (null == e || null == t || !Ze(e) && !Ze(t) ? e != e && t != t : function (e, t, i, n, o, c) {
      var m = Ge(e),
        d = Ge(t),
        y = m ? u : He(e),
        g = d ? u : He(t),
        z = (y = y == a ? b : y) == b,
        x = (g = g == a ? b : g) == b,
        E = y == g;
      if (E && Ue(e)) {
        if (!Ue(t)) return !1;
        m = !0, z = !1;
      }
      if (E && !z) return c || (c = new je()), m || qe(e) ? Ce(e, t, i, n, o, c) : function (e, t, i, n, o, a, u) {
        switch (i) {
          case j:
            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
            e = e.buffer, t = t.buffer;
          case V:
            return !(e.byteLength != t.byteLength || !a(new se(e), new se(t)));
          case h:
          case l:
          case v:
            return Be(+e, +t);
          case f:
            return e.name == t.name && e.message == t.message;
          case w:
          case _:
            return e == t + "";
          case p:
            var c = $;
          case S:
            var m = n & s;
            if (c || (c = Y), e.size != t.size && !m) return !1;
            var d = u.get(e);
            if (d) return d == t;
            n |= r, u.set(e, t);
            var y = Ce(c(e), c(t), n, o, a, u);
            return u["delete"](e), y;
          case I:
            if (_e) return _e.call(e) == _e.call(t);
        }
        return !1;
      }(e, t, y, i, n, o, c);
      if (!(i & s)) {
        var L = z && q.call(e, "__wrapped__"),
          O = x && q.call(t, "__wrapped__");
        if (L || O) {
          var D = L ? e.value() : e,
            N = O ? t.value() : t;
          return c || (c = new je()), o(D, N, i, n, c);
        }
      }
      if (!E) return !1;
      return c || (c = new je()), function (e, t, i, n, r, o) {
        var a = i & s,
          u = Te(e),
          c = u.length,
          h = Te(t),
          l = h.length;
        if (c != l && !a) return !1;
        var f = c;
        for (; f--;) {
          var m = u[f];
          if (!(a ? m in t : q.call(t, m))) return !1;
        }
        var d = o.get(e);
        if (d && o.get(t)) return d == t;
        var p = !0;
        o.set(e, t), o.set(t, e);
        var v = a;
        for (; ++f < c;) {
          var y = e[m = u[f]],
            b = t[m];
          if (n) var g = a ? n(b, y, m, t, e, o) : n(y, b, m, e, t, o);
          if (!(void 0 === g ? y === b || r(y, b, i, n, o) : g)) {
            p = !1;
            break;
          }
          v || (v = "constructor" == m);
        }
        if (p && !v) {
          var z = e.constructor,
            w = t.constructor;
          z == w || !("constructor" in e) || !("constructor" in t) || "function" == typeof z && z instanceof z && "function" == typeof w && w instanceof w || (p = !1);
        }
        return o["delete"](e), o["delete"](t), p;
      }(e, t, i, n, o, c);
    }(e, t, i, n, Me, o));
  }
  function Pe(e) {
    return !(!Ke(e) || function (e) {
      return !!Q && Q in e;
    }(e)) && (Xe(e) ? te : L).test(Ye(e));
  }
  function Ae(e) {
    if (i = (t = e) && t.constructor, n = "function" == typeof i && i.prototype || J, t !== n) return he(e);
    var t,
      i,
      n,
      s = [];
    for (var r in Object(e)) q.call(e, r) && "constructor" != r && s.push(r);
    return s;
  }
  function Ce(e, t, i, n, o, a) {
    var u = i & s,
      c = e.length,
      h = t.length;
    if (c != h && !(u && h > c)) return !1;
    var l = a.get(e);
    if (l && a.get(t)) return l == t;
    var f = -1,
      m = !0,
      d = i & r ? new Ve() : void 0;
    for (a.set(e, t), a.set(t, e); ++f < c;) {
      var p = e[f],
        v = t[f];
      if (n) var y = u ? n(v, p, f, t, e, a) : n(p, v, f, e, t, a);
      if (void 0 !== y) {
        if (y) continue;
        m = !1;
        break;
      }
      if (d) {
        if (!H(t, function (e, t) {
          if (s = t, !d.has(s) && (p === e || o(p, e, i, n, a))) return d.push(t);
          var s;
        })) {
          m = !1;
          break;
        }
      } else if (p !== v && !o(p, v, i, n, a)) {
        m = !1;
        break;
      }
    }
    return a["delete"](e), a["delete"](t), m;
  }
  function Te(e) {
    return function (e, t, i) {
      var n = t(e);
      return Ge(e) ? n : function (e, t) {
        for (var i = -1, n = t.length, s = e.length; ++i < n;) e[s + i] = t[i];
        return e;
      }(n, i(e));
    }(e, Qe, Re);
  }
  function Fe(e, t) {
    var i,
      n,
      s = e.__data__;
    return ("string" == (n = _typeof(i = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== i : null === i) ? s["string" == typeof t ? "string" : "hash"] : s.map;
  }
  function ke(e, t) {
    var i = function (e, t) {
      return null == e ? void 0 : e[t];
    }(e, t);
    return Pe(i) ? i : void 0;
  }
  Ie.prototype.clear = function () {
    this.__data__ = ve ? ve(null) : {}, this.size = 0;
  }, Ie.prototype["delete"] = function (e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  }, Ie.prototype.get = function (e) {
    var t = this.__data__;
    if (ve) {
      var i = t[e];
      return i === n ? void 0 : i;
    }
    return q.call(t, e) ? t[e] : void 0;
  }, Ie.prototype.has = function (e) {
    var t = this.__data__;
    return ve ? void 0 !== t[e] : q.call(t, e);
  }, Ie.prototype.set = function (e, t) {
    var i = this.__data__;
    return this.size += this.has(e) ? 0 : 1, i[e] = ve && void 0 === t ? n : t, this;
  }, xe.prototype.clear = function () {
    this.__data__ = [], this.size = 0;
  }, xe.prototype["delete"] = function (e) {
    var t = this.__data__,
      i = Oe(t, e);
    return !(i < 0) && (i == t.length - 1 ? t.pop() : oe.call(t, i, 1), --this.size, !0);
  }, xe.prototype.get = function (e) {
    var t = this.__data__,
      i = Oe(t, e);
    return i < 0 ? void 0 : t[i][1];
  }, xe.prototype.has = function (e) {
    return Oe(this.__data__, e) > -1;
  }, xe.prototype.set = function (e, t) {
    var i = this.__data__,
      n = Oe(i, e);
    return n < 0 ? (++this.size, i.push([e, t])) : i[n][1] = t, this;
  }, Ee.prototype.clear = function () {
    this.size = 0, this.__data__ = {
      hash: new Ie(),
      map: new (fe || xe)(),
      string: new Ie()
    };
  }, Ee.prototype["delete"] = function (e) {
    var t = Fe(this, e)["delete"](e);
    return this.size -= t ? 1 : 0, t;
  }, Ee.prototype.get = function (e) {
    return Fe(this, e).get(e);
  }, Ee.prototype.has = function (e) {
    return Fe(this, e).has(e);
  }, Ee.prototype.set = function (e, t) {
    var i = Fe(this, e),
      n = i.size;
    return i.set(e, t), this.size += i.size == n ? 0 : 1, this;
  }, Ve.prototype.add = Ve.prototype.push = function (e) {
    return this.__data__.set(e, n), this;
  }, Ve.prototype.has = function (e) {
    return this.__data__.has(e);
  }, je.prototype.clear = function () {
    this.__data__ = new xe(), this.size = 0;
  }, je.prototype["delete"] = function (e) {
    var t = this.__data__,
      i = t["delete"](e);
    return this.size = t.size, i;
  }, je.prototype.get = function (e) {
    return this.__data__.get(e);
  }, je.prototype.has = function (e) {
    return this.__data__.has(e);
  }, je.prototype.set = function (e, t) {
    var i = this.__data__;
    if (i instanceof xe) {
      var n = i.__data__;
      if (!fe || n.length < 199) return n.push([e, t]), this.size = ++i.size, this;
      i = this.__data__ = new Ee(n);
    }
    return i.set(e, t), this.size = i.size, this;
  };
  var Re = ue ? function (e) {
      return null == e ? [] : (e = Object(e), function (e, t) {
        for (var i = -1, n = null == e ? 0 : e.length, s = 0, r = []; ++i < n;) {
          var o = e[i];
          t(o, i, e) && (r[s++] = o);
        }
        return r;
      }(ue(e), function (t) {
        return re.call(e, t);
      }));
    } : function () {
      return [];
    },
    He = De;
  function $e(e, t) {
    return !!(t = null == t ? o : t) && ("number" == typeof e || O.test(e)) && e > -1 && e % 1 == 0 && e < t;
  }
  function Ye(e) {
    if (null != e) {
      try {
        return Z.call(e);
      } catch (e) {}
      try {
        return e + "";
      } catch (e) {}
    }
    return "";
  }
  function Be(e, t) {
    return e === t || e != e && t != t;
  }
  (le && He(new le(new ArrayBuffer(1))) != j || fe && He(new fe()) != p || me && He(me.resolve()) != g || de && He(new de()) != S || pe && He(new pe()) != E) && (He = function He(e) {
    var t = De(e),
      i = t == b ? e.constructor : void 0,
      n = i ? Ye(i) : "";
    if (n) switch (n) {
      case ye:
        return j;
      case be:
        return p;
      case ge:
        return g;
      case ze:
        return S;
      case we:
        return E;
    }
    return t;
  });
  var We = Ne(function () {
      return arguments;
    }()) ? Ne : function (e) {
      return Ze(e) && q.call(e, "callee") && !re.call(e, "callee");
    },
    Ge = Array.isArray;
  var Ue = ce || function () {
    return !1;
  };
  function Xe(e) {
    if (!Ke(e)) return !1;
    var t = De(e);
    return t == m || t == d || t == c || t == z;
  }
  function Je(e) {
    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= o;
  }
  function Ke(e) {
    var t = _typeof(e);
    return null != e && ("object" == t || "function" == t);
  }
  function Ze(e) {
    return null != e && "object" == _typeof(e);
  }
  var qe = R ? function (e) {
    return function (t) {
      return e(t);
    };
  }(R) : function (e) {
    return Ze(e) && Je(e.length) && !!D[De(e)];
  };
  function Qe(e) {
    return null != (t = e) && Je(t.length) && !Xe(t) ? Le(e) : Ae(e);
    var t;
  }
  e.exports = function (e, t) {
    return Me(e, t);
  };
}(y, y.exports);
var b = i(y.exports);
function g(e, t, i) {
  return e[t] ? e[t][0] ? e[t][0][i] : e[t][i] : "contentBoxSize" === t ? e.contentRect["inlineSize" === i ? "width" : "height"] : void 0;
}
function z(t) {
  void 0 === t && (t = {});
  var i = t.onResize,
    n = e.useRef(void 0);
  n.current = i;
  var s = t.round || Math.round,
    r = e.useRef(),
    o = e.useState({
      width: void 0,
      height: void 0
    }),
    a = o[0],
    u = o[1],
    c = e.useRef(!1);
  e.useEffect(function () {
    return c.current = !1, function () {
      c.current = !0;
    };
  }, []);
  var h = e.useRef({
      width: void 0,
      height: void 0
    }),
    l = function (t, i) {
      var n = e.useRef(null),
        s = e.useRef(null);
      s.current = i;
      var r = e.useRef(null);
      e.useEffect(function () {
        o();
      });
      var o = e.useCallback(function () {
        var e = r.current,
          i = s.current,
          o = e || (i ? i instanceof Element ? i : i.current : null);
        n.current && n.current.element === o && n.current.subscriber === t || (n.current && n.current.cleanup && n.current.cleanup(), n.current = {
          element: o,
          subscriber: t,
          cleanup: o ? t(o) : void 0
        });
      }, [t]);
      return e.useEffect(function () {
        return function () {
          n.current && n.current.cleanup && (n.current.cleanup(), n.current = null);
        };
      }, []), e.useCallback(function (e) {
        r.current = e, o();
      }, [o]);
    }(e.useCallback(function (e) {
      return r.current && r.current.box === t.box && r.current.round === s || (r.current = {
        box: t.box,
        round: s,
        instance: new ResizeObserver(function (e) {
          var i = e[0],
            r = "border-box" === t.box ? "borderBoxSize" : "device-pixel-content-box" === t.box ? "devicePixelContentBoxSize" : "contentBoxSize",
            o = g(i, r, "inlineSize"),
            a = g(i, r, "blockSize"),
            l = o ? s(o) : void 0,
            f = a ? s(a) : void 0;
          if (h.current.width !== l || h.current.height !== f) {
            var m = {
              width: l,
              height: f
            };
            h.current.width = l, h.current.height = f, n.current ? n.current(m) : c.current || u(m);
          }
        })
      }), r.current.instance.observe(e, {
        box: t.box
      }), function () {
        r.current && r.current.instance.unobserve(e);
      };
    }, [t.box, s]), t.ref);
  return e.useMemo(function () {
    return {
      ref: l,
      width: a.width,
      height: a.height
    };
  }, [l, a.width, a.height]);
}
var w = "allotment-module_splitView__L-yRc",
  S = "allotment-module_sashContainer__fzwJF",
  _ = "allotment-module_splitViewContainer__rQnVa",
  I = "allotment-module_splitViewView__MGZ6O",
  x = "allotment-module_vertical__WSwwa",
  E = "allotment-module_horizontal__7doS8",
  V = "allotment-module_separatorBorder__x-rDS";
var j,
  L = !1,
  O = !1;
"object" == (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) && (j = navigator.userAgent, O = j.indexOf("Macintosh") >= 0, L = (j.indexOf("Macintosh") >= 0 || j.indexOf("iPad") >= 0 || j.indexOf("iPhone") >= 0) && !!navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
var D = L,
  N = O,
  M = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement ? e.useLayoutEffect : e.useEffect;
var P = /*#__PURE__*/function () {
  function P() {
    _classCallCheck(this, P);
    this._size = void 0;
  }
  return _createClass(P, [{
    key: "getSize",
    value: function getSize() {
      return this._size;
    }
  }, {
    key: "setSize",
    value: function setSize(e) {
      this._size = e;
    }
  }]);
}();
function A(e, t) {
  var i = e.length,
    n = i - t.length;
  return n >= 0 && e.slice(n, i) === t;
}
var C = {
  exports: {}
};
!function (e) {
  var t = Object.prototype.hasOwnProperty,
    i = "~";
  function n() {}
  function s(e, t, i) {
    this.fn = e, this.context = t, this.once = i || !1;
  }
  function r(e, t, n, r, o) {
    if ("function" != typeof n) throw new TypeError("The listener must be a function");
    var a = new s(n, r || e, o),
      u = i ? i + t : t;
    return e._events[u] ? e._events[u].fn ? e._events[u] = [e._events[u], a] : e._events[u].push(a) : (e._events[u] = a, e._eventsCount++), e;
  }
  function o(e, t) {
    0 == --e._eventsCount ? e._events = new n() : delete e._events[t];
  }
  function a() {
    this._events = new n(), this._eventsCount = 0;
  }
  Object.create && (n.prototype = Object.create(null), new n().__proto__ || (i = !1)), a.prototype.eventNames = function () {
    var e,
      n,
      s = [];
    if (0 === this._eventsCount) return s;
    for (n in e = this._events) t.call(e, n) && s.push(i ? n.slice(1) : n);
    return Object.getOwnPropertySymbols ? s.concat(Object.getOwnPropertySymbols(e)) : s;
  }, a.prototype.listeners = function (e) {
    var t = i ? i + e : e,
      n = this._events[t];
    if (!n) return [];
    if (n.fn) return [n.fn];
    for (var s = 0, r = n.length, o = new Array(r); s < r; s++) o[s] = n[s].fn;
    return o;
  }, a.prototype.listenerCount = function (e) {
    var t = i ? i + e : e,
      n = this._events[t];
    return n ? n.fn ? 1 : n.length : 0;
  }, a.prototype.emit = function (e, t, n, s, r, o) {
    var a = i ? i + e : e;
    if (!this._events[a]) return !1;
    var u,
      c,
      h = this._events[a],
      l = arguments.length;
    if (h.fn) {
      switch (h.once && this.removeListener(e, h.fn, void 0, !0), l) {
        case 1:
          return h.fn.call(h.context), !0;
        case 2:
          return h.fn.call(h.context, t), !0;
        case 3:
          return h.fn.call(h.context, t, n), !0;
        case 4:
          return h.fn.call(h.context, t, n, s), !0;
        case 5:
          return h.fn.call(h.context, t, n, s, r), !0;
        case 6:
          return h.fn.call(h.context, t, n, s, r, o), !0;
      }
      for (c = 1, u = new Array(l - 1); c < l; c++) u[c - 1] = arguments[c];
      h.fn.apply(h.context, u);
    } else {
      var f,
        m = h.length;
      for (c = 0; c < m; c++) switch (h[c].once && this.removeListener(e, h[c].fn, void 0, !0), l) {
        case 1:
          h[c].fn.call(h[c].context);
          break;
        case 2:
          h[c].fn.call(h[c].context, t);
          break;
        case 3:
          h[c].fn.call(h[c].context, t, n);
          break;
        case 4:
          h[c].fn.call(h[c].context, t, n, s);
          break;
        default:
          if (!u) for (f = 1, u = new Array(l - 1); f < l; f++) u[f - 1] = arguments[f];
          h[c].fn.apply(h[c].context, u);
      }
    }
    return !0;
  }, a.prototype.on = function (e, t, i) {
    return r(this, e, t, i, !1);
  }, a.prototype.once = function (e, t, i) {
    return r(this, e, t, i, !0);
  }, a.prototype.removeListener = function (e, t, n, s) {
    var r = i ? i + e : e;
    if (!this._events[r]) return this;
    if (!t) return o(this, r), this;
    var a = this._events[r];
    if (a.fn) a.fn !== t || s && !a.once || n && a.context !== n || o(this, r);else {
      for (var u = 0, c = [], h = a.length; u < h; u++) (a[u].fn !== t || s && !a[u].once || n && a[u].context !== n) && c.push(a[u]);
      c.length ? this._events[r] = 1 === c.length ? c[0] : c : o(this, r);
    }
    return this;
  }, a.prototype.removeAllListeners = function (e) {
    var t;
    return e ? (t = i ? i + e : e, this._events[t] && o(this, t)) : (this._events = new n(), this._eventsCount = 0), this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = i, a.EventEmitter = a, e.exports = a;
}(C);
var T = i(C.exports);
function F(e, t) {
  var i = e.indexOf(t);
  i > -1 && (e.splice(i, 1), e.unshift(t));
}
function k(e, t) {
  var i = e.indexOf(t);
  i > -1 && (e.splice(i, 1), e.push(t));
}
function R(e, t) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var n = Math.max(0, Math.ceil((t - e) / i)),
    s = new Array(n);
  var r = -1;
  for (; ++r < n;) s[r] = e + r * i;
  return s;
}
var H = NaN,
  $ = "[object Symbol]",
  Y = /^\s+|\s+$/g,
  B = /^[-+]0x[0-9a-f]+$/i,
  W = /^0b[01]+$/i,
  G = /^0o[0-7]+$/i,
  U = parseInt,
  X = "object" == _typeof(t) && t && t.Object === Object && t,
  J = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
  K = X || J || Function("return this")(),
  Z = Object.prototype.toString,
  q = Math.max,
  Q = Math.min,
  ee = function ee() {
    return K.Date.now();
  };
function te(e) {
  var t = _typeof(e);
  return !!e && ("object" == t || "function" == t);
}
function ie(e) {
  if ("number" == typeof e) return e;
  if (function (e) {
    return "symbol" == _typeof(e) || function (e) {
      return !!e && "object" == _typeof(e);
    }(e) && Z.call(e) == $;
  }(e)) return H;
  if (te(e)) {
    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
    e = te(t) ? t + "" : t;
  }
  if ("string" != typeof e) return 0 === e ? e : +e;
  e = e.replace(Y, "");
  var i = W.test(e);
  return i || G.test(e) ? U(e.slice(2), i ? 2 : 8) : B.test(e) ? H : +e;
}
var ne = i(function (e, t, i) {
    var n,
      s,
      r,
      o,
      a,
      u,
      c = 0,
      h = !1,
      l = !1,
      f = !0;
    if ("function" != typeof e) throw new TypeError("Expected a function");
    function m(t) {
      var i = n,
        r = s;
      return n = s = void 0, c = t, o = e.apply(r, i);
    }
    function d(e) {
      var i = e - u;
      return void 0 === u || i >= t || i < 0 || l && e - c >= r;
    }
    function p() {
      var e = ee();
      if (d(e)) return v(e);
      a = setTimeout(p, function (e) {
        var i = t - (e - u);
        return l ? Q(i, r - (e - c)) : i;
      }(e));
    }
    function v(e) {
      return a = void 0, f && n ? m(e) : (n = s = void 0, o);
    }
    function y() {
      var e = ee(),
        i = d(e);
      if (n = arguments, s = this, u = e, i) {
        if (void 0 === a) return function (e) {
          return c = e, a = setTimeout(p, t), h ? m(e) : o;
        }(u);
        if (l) return a = setTimeout(p, t), m(u);
      }
      return void 0 === a && (a = setTimeout(p, t)), o;
    }
    return t = ie(t) || 0, te(i) && (h = !!i.leading, r = (l = "maxWait" in i) ? q(ie(i.maxWait) || 0, t) : r, f = "trailing" in i ? !!i.trailing : f), y.cancel = function () {
      void 0 !== a && clearTimeout(a), c = 0, n = u = s = a = void 0;
    }, y.flush = function () {
      return void 0 === a ? o : v(ee());
    }, y;
  }),
  se = "sash-module_sash__K-9lB",
  re = "sash-module_disabled__Hm-wx",
  oe = "sash-module_mac__Jf6OJ",
  ae = "sash-module_vertical__pB-rs",
  ue = "sash-module_minimum__-UKxp",
  ce = "sash-module_maximum__TCWxD",
  he = "sash-module_horizontal__kFbiw",
  le = "sash-module_hover__80W6I",
  fe = "sash-module_active__bJspD";
var me = function (e) {
    return e.Vertical = "VERTICAL", e.Horizontal = "HORIZONTAL", e;
  }({}),
  de = function (e) {
    return e.Disabled = "DISABLED", e.Minimum = "MINIMUM", e.Maximum = "MAXIMUM", e.Enabled = "ENABLED", e;
  }({}),
  pe = D ? 20 : 8;
var ve = new T();
var ye = /*#__PURE__*/function (_T) {
  function ye(e, t, i) {
    var _i$orientation;
    var _this;
    _classCallCheck(this, ye);
    _this = _callSuper(this, ye), _this.el = void 0, _this.layoutProvider = void 0, _this.orientation = void 0, _this.size = void 0, _this.hoverDelay = 300, _this.hoverDelayer = ne(function (e) {
      return e.classList.add("sash-hover", le);
    }, _this.hoverDelay), _this._state = de.Enabled, _this.onPointerStart = function (e) {
      var t = e.pageX,
        i = e.pageY,
        n = {
          startX: t,
          currentX: t,
          startY: i,
          currentY: i
        };
      _this.el.classList.add("sash-active", fe), _this.emit("start", n), _this.el.setPointerCapture(e.pointerId);
      var s = function s(e) {
          e.preventDefault();
          var n = {
            startX: t,
            currentX: e.pageX,
            startY: i,
            currentY: e.pageY
          };
          _this.emit("change", n);
        },
        r = function r(e) {
          e.preventDefault(), _this.el.classList.remove("sash-active", fe), _this.hoverDelayer.cancel(), _this.emit("end"), _this.el.releasePointerCapture(e.pointerId), window.removeEventListener("pointermove", s), window.removeEventListener("pointerup", r);
        };
      window.addEventListener("pointermove", s), window.addEventListener("pointerup", r);
    }, _this.onPointerDoublePress = function () {
      _this.emit("reset");
    }, _this.onMouseEnter = function () {
      _this.el.classList.contains(fe) ? (_this.hoverDelayer.cancel(), _this.el.classList.add("sash-hover", le)) : _this.hoverDelayer(_this.el);
    }, _this.onMouseLeave = function () {
      _this.hoverDelayer.cancel(), _this.el.classList.remove("sash-hover", le);
    }, _this.el = document.createElement("div"), _this.el.classList.add("sash", se), _this.el.dataset.testid = "sash", e.append(_this.el), N && _this.el.classList.add("sash-mac", oe), _this.el.addEventListener("pointerdown", _this.onPointerStart), _this.el.addEventListener("dblclick", _this.onPointerDoublePress), _this.el.addEventListener("mouseenter", _this.onMouseEnter), _this.el.addEventListener("mouseleave", _this.onMouseLeave), "number" == typeof i.size ? (_this.size = i.size, i.orientation === me.Vertical ? _this.el.style.width = "".concat(_this.size, "px") : _this.el.style.height = "".concat(_this.size, "px")) : (_this.size = pe, ve.on("onDidChangeGlobalSize", function (e) {
      _this.size = e, _this.layout();
    })), _this.layoutProvider = t, _this.orientation = (_i$orientation = i.orientation) !== null && _i$orientation !== void 0 ? _i$orientation : me.Vertical, _this.orientation === me.Horizontal ? (_this.el.classList.add("sash-horizontal", he), _this.el.classList.remove("sash-vertical", ae)) : (_this.el.classList.remove("sash-horizontal", he), _this.el.classList.add("sash-vertical", ae)), _this.layout();
    return _this;
  }
  _inherits(ye, _T);
  return _createClass(ye, [{
    key: "state",
    get: function get() {
      return this._state;
    },
    set: function set(e) {
      this._state !== e && (this.el.classList.toggle(re, e === de.Disabled), this.el.classList.toggle("sash-disabled", e === de.Disabled), this.el.classList.toggle(ue, e === de.Minimum), this.el.classList.toggle("sash-minimum", e === de.Minimum), this.el.classList.toggle(ce, e === de.Maximum), this.el.classList.toggle("sash-maximum", e === de.Maximum), this._state = e, this.emit("enablementChange", e));
    }
  }, {
    key: "layout",
    value: function layout() {
      if (this.orientation === me.Vertical) {
        var _e2 = this.layoutProvider;
        this.el.style.left = _e2.getVerticalSashLeft(this) - this.size / 2 + "px", _e2.getVerticalSashTop && (this.el.style.top = _e2.getVerticalSashTop(this) + "px"), _e2.getVerticalSashHeight && (this.el.style.height = _e2.getVerticalSashHeight(this) + "px");
      } else {
        var _e3 = this.layoutProvider;
        this.el.style.top = _e3.getHorizontalSashTop(this) - this.size / 2 + "px", _e3.getHorizontalSashLeft && (this.el.style.left = _e3.getHorizontalSashLeft(this) + "px"), _e3.getHorizontalSashWidth && (this.el.style.width = _e3.getHorizontalSashWidth(this) + "px");
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var _this2 = this;
      this.el.removeEventListener("pointerdown", this.onPointerStart), this.el.removeEventListener("dblclick", this.onPointerDoublePress), this.el.removeEventListener("mouseenter", this.onMouseEnter), this.el.removeEventListener("mouseleave", function () {
        return _this2.onMouseLeave;
      }), this.el.remove();
    }
  }]);
}(T);
var be;
var ge;
(ge = be || (be = {})).Distribute = {
  type: "distribute"
}, ge.Split = function (e) {
  return {
    type: "split",
    index: e
  };
}, ge.Invisible = function (e) {
  return {
    type: "invisible",
    cachedVisibleSize: e
  };
};
var ze = function (e) {
  return e.Normal = "NORMAL", e.Low = "LOW", e.High = "HIGH", e;
}({});
var we = /*#__PURE__*/function () {
  function we(e, t, i) {
    _classCallCheck(this, we);
    this.container = void 0, this.view = void 0, this._size = void 0, this._cachedVisibleSize = void 0, this.container = e, this.view = t, this.container.classList.add("split-view-view", I), this.container.dataset.testid = "split-view-view", "number" == typeof i ? (this._size = i, this._cachedVisibleSize = void 0, e.classList.add("split-view-view-visible")) : (this._size = 0, this._cachedVisibleSize = i.cachedVisibleSize);
  }
  return _createClass(we, [{
    key: "size",
    get: function get() {
      return this._size;
    },
    set: function set(e) {
      this._size = e;
    }
  }, {
    key: "priority",
    get: function get() {
      return this.view.priority;
    }
  }, {
    key: "snap",
    get: function get() {
      return !!this.view.snap;
    }
  }, {
    key: "cachedVisibleSize",
    get: function get() {
      return this._cachedVisibleSize;
    }
  }, {
    key: "visible",
    get: function get() {
      return void 0 === this._cachedVisibleSize;
    }
  }, {
    key: "setVisible",
    value: function setVisible(e, t) {
      e !== this.visible && (e ? (this.size = v(this._cachedVisibleSize, this.viewMinimumSize, this.viewMaximumSize), this._cachedVisibleSize = void 0) : (this._cachedVisibleSize = "number" == typeof t ? t : this.size, this.size = 0), this.container.classList.toggle("split-view-view-visible", e), this.view.setVisible && this.view.setVisible(e));
    }
  }, {
    key: "minimumSize",
    get: function get() {
      return this.visible ? this.view.minimumSize : 0;
    }
  }, {
    key: "viewMinimumSize",
    get: function get() {
      return this.view.minimumSize;
    }
  }, {
    key: "maximumSize",
    get: function get() {
      return this.visible ? this.view.maximumSize : 0;
    }
  }, {
    key: "viewMaximumSize",
    get: function get() {
      return this.view.maximumSize;
    }
  }, {
    key: "enabled",
    set: function set(e) {
      this.container.style.pointerEvents = e ? "" : "none";
    }
  }, {
    key: "layout",
    value: function layout(e) {
      this.layoutContainer(e), this.view.layout(this.size, e);
    }
  }]);
}();
var Se = /*#__PURE__*/function (_we) {
  function Se() {
    _classCallCheck(this, Se);
    return _callSuper(this, Se, arguments);
  }
  _inherits(Se, _we);
  return _createClass(Se, [{
    key: "layoutContainer",
    value: function layoutContainer(e) {
      this.container.style.left = "".concat(e, "px"), this.container.style.width = "".concat(this.size, "px");
    }
  }]);
}(we);
var _e = /*#__PURE__*/function (_we2) {
  function _e() {
    _classCallCheck(this, _e);
    return _callSuper(this, _e, arguments);
  }
  _inherits(_e, _we2);
  return _createClass(_e, [{
    key: "layoutContainer",
    value: function layoutContainer(e) {
      this.container.style.top = "".concat(e, "px"), this.container.style.height = "".concat(this.size, "px");
    }
  }]);
}(we);
var Ie = /*#__PURE__*/function (_T2) {
  function Ie(e) {
    var _t$orientation, _t$proportionalLayout;
    var _this3;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i = arguments.length > 2 ? arguments[2] : undefined;
    var n = arguments.length > 3 ? arguments[3] : undefined;
    var s = arguments.length > 4 ? arguments[4] : undefined;
    _classCallCheck(this, Ie);
    if (_this3 = _callSuper(this, Ie), _this3.onDidChange = void 0, _this3.onDidDragStart = void 0, _this3.onDidDragEnd = void 0, _this3.orientation = void 0, _this3.sashContainer = void 0, _this3.size = 0, _this3.contentSize = 0, _this3.proportions = void 0, _this3.viewItems = [], _this3.sashItems = [], _this3.sashDragState = void 0, _this3.proportionalLayout = void 0, _this3.getSashOrthogonalSize = void 0, _this3._startSnappingEnabled = !0, _this3._endSnappingEnabled = !0, _this3.onSashEnd = function (e) {
      _this3.emit("sashchange", e), _this3.saveProportions();
      var _iterator = _createForOfIteratorHelper(_this3.viewItems),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e4 = _step.value;
          _e4.enabled = !0;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }, _this3.orientation = (_t$orientation = t.orientation) !== null && _t$orientation !== void 0 ? _t$orientation : me.Vertical, _this3.proportionalLayout = (_t$proportionalLayout = t.proportionalLayout) !== null && _t$proportionalLayout !== void 0 ? _t$proportionalLayout : !0, _this3.getSashOrthogonalSize = t.getSashOrthogonalSize, i && (_this3.onDidChange = i), n && (_this3.onDidDragStart = n), s && (_this3.onDidDragEnd = s), _this3.sashContainer = document.createElement("div"), _this3.sashContainer.classList.add("sash-container", S), e.prepend(_this3.sashContainer), t.descriptor) {
      _this3.size = t.descriptor.size;
      var _iterator2 = _createForOfIteratorHelper(t.descriptor.views.entries()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
            _e5 = _step2$value[0],
            _i = _step2$value[1];
          var _t = _i.size,
            _n = _i.container,
            _s = _i.view;
          _this3.addView(_n, _s, _t, _e5, !0);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      _this3.contentSize = _this3.viewItems.reduce(function (e, t) {
        return e + t.size;
      }, 0), _this3.saveProportions();
    }
    return _assertThisInitialized(_this3);
  }
  _inherits(Ie, _T2);
  return _createClass(Ie, [{
    key: "startSnappingEnabled",
    get: function get() {
      return this._startSnappingEnabled;
    },
    set: function set(e) {
      this._startSnappingEnabled !== e && (this._startSnappingEnabled = e, this.updateSashEnablement());
    }
  }, {
    key: "endSnappingEnabled",
    get: function get() {
      return this._endSnappingEnabled;
    },
    set: function set(e) {
      this._endSnappingEnabled !== e && (this._endSnappingEnabled = e, this.updateSashEnablement());
    }
  }, {
    key: "addView",
    value: function addView(e, t, i) {
      var _this4 = this;
      var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.viewItems.length;
      var s = arguments.length > 4 ? arguments[4] : undefined;
      var r;
      r = "number" == typeof i ? i : "split" === i.type ? this.getViewSize(i.index) / 2 : "invisible" === i.type ? {
        cachedVisibleSize: i.cachedVisibleSize
      } : t.minimumSize;
      var o = this.orientation === me.Vertical ? new _e(e, t, r) : new Se(e, t, r);
      if (this.viewItems.splice(n, 0, o), this.viewItems.length > 1) {
        var _e6 = this.orientation === me.Vertical ? new ye(this.sashContainer, {
            getHorizontalSashTop: function getHorizontalSashTop(e) {
              return _this4.getSashPosition(e);
            },
            getHorizontalSashWidth: this.getSashOrthogonalSize
          }, {
            orientation: me.Horizontal
          }) : new ye(this.sashContainer, {
            getVerticalSashLeft: function getVerticalSashLeft(e) {
              return _this4.getSashPosition(e);
            },
            getVerticalSashHeight: this.getSashOrthogonalSize
          }, {
            orientation: me.Vertical
          }),
          _t2 = this.orientation === me.Vertical ? function (t) {
            return {
              sash: _e6,
              start: t.startY,
              current: t.currentY
            };
          } : function (t) {
            return {
              sash: _e6,
              start: t.startX,
              current: t.currentX
            };
          };
        _e6.on("start", function (e) {
          var _this4$onDidDragStart;
          _this4.emit("sashDragStart"), _this4.onSashStart(_t2(e));
          var i = _this4.viewItems.map(function (e) {
            return e.size;
          });
          (_this4$onDidDragStart = _this4.onDidDragStart) === null || _this4$onDidDragStart === void 0 || _this4$onDidDragStart.call(_this4, i);
        }), _e6.on("change", function (e) {
          return _this4.onSashChange(_t2(e));
        }), _e6.on("end", function () {
          var _this4$onDidDragEnd;
          _this4.emit("sashDragEnd"), _this4.onSashEnd(_this4.sashItems.findIndex(function (t) {
            return t.sash === _e6;
          }));
          var t = _this4.viewItems.map(function (e) {
            return e.size;
          });
          (_this4$onDidDragEnd = _this4.onDidDragEnd) === null || _this4$onDidDragEnd === void 0 || _this4$onDidDragEnd.call(_this4, t);
        }), _e6.on("reset", function () {
          var t = _this4.sashItems.findIndex(function (t) {
              return t.sash === _e6;
            }),
            i = R(t, -1, -1),
            n = R(t + 1, _this4.viewItems.length),
            s = _this4.findFirstSnapIndex(i),
            r = _this4.findFirstSnapIndex(n);
          ("number" != typeof s || _this4.viewItems[s].visible) && ("number" != typeof r || _this4.viewItems[r].visible) && _this4.emit("sashreset", t);
        });
        var _i2 = {
          sash: _e6
        };
        this.sashItems.splice(n - 1, 0, _i2);
      }
      s || this.relayout(), s || "number" == typeof i || "distribute" !== i.type || this.distributeViewSizes();
    }
  }, {
    key: "removeView",
    value: function removeView(e, t) {
      if (e < 0 || e >= this.viewItems.length) throw new Error("Index out of bounds");
      var i = this.viewItems.splice(e, 1)[0].view;
      if (this.viewItems.length >= 1) {
        var _t3 = Math.max(e - 1, 0);
        this.sashItems.splice(_t3, 1)[0].sash.dispose();
      }
      return this.relayout(), t && "distribute" === t.type && this.distributeViewSizes(), i;
    }
  }, {
    key: "moveView",
    value: function moveView(e, t, i) {
      var n = this.getViewCachedVisibleSize(t),
        s = void 0 === n ? this.getViewSize(t) : be.Invisible(n),
        r = this.removeView(t);
      this.addView(e, r, s, i);
    }
  }, {
    key: "getViewCachedVisibleSize",
    value: function getViewCachedVisibleSize(e) {
      if (e < 0 || e >= this.viewItems.length) throw new Error("Index out of bounds");
      return this.viewItems[e].cachedVisibleSize;
    }
  }, {
    key: "layout",
    value: function layout() {
      var _this5 = this;
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.size;
      var t = Math.max(this.size, this.contentSize);
      if (this.size = e, this.proportions) for (var _t4 = 0; _t4 < this.viewItems.length; _t4++) {
        var _i3 = this.viewItems[_t4];
        _i3.size = v(Math.round(this.proportions[_t4] * e), _i3.minimumSize, _i3.maximumSize);
      } else {
        var _i4 = R(0, this.viewItems.length),
          _n2 = _i4.filter(function (e) {
            return _this5.viewItems[e].priority === ze.Low;
          }),
          _s2 = _i4.filter(function (e) {
            return _this5.viewItems[e].priority === ze.High;
          });
        this.resize(this.viewItems.length - 1, e - t, void 0, _n2, _s2);
      }
      this.distributeEmptySpace(), this.layoutViews();
    }
  }, {
    key: "resizeView",
    value: function resizeView(e, t) {
      var _this6 = this;
      if (e < 0 || e >= this.viewItems.length) return;
      var i = R(0, this.viewItems.length).filter(function (t) {
          return t !== e;
        }),
        n = [].concat(_toConsumableArray(i.filter(function (e) {
          return _this6.viewItems[e].priority === ze.Low;
        })), [e]),
        s = i.filter(function (e) {
          return _this6.viewItems[e].priority === ze.High;
        }),
        r = this.viewItems[e];
      t = Math.round(t), t = v(t, r.minimumSize, Math.min(r.maximumSize, this.size)), r.size = t, this.relayout(n, s);
    }
  }, {
    key: "resizeViews",
    value: function resizeViews(e) {
      for (var _t5 = 0; _t5 < e.length; _t5++) {
        var _i5 = this.viewItems[_t5];
        var _n3 = e[_t5];
        _n3 = Math.round(_n3), _n3 = v(_n3, _i5.minimumSize, Math.min(_i5.maximumSize, this.size)), _i5.size = _n3;
      }
      this.contentSize = this.viewItems.reduce(function (e, t) {
        return e + t.size;
      }, 0), this.saveProportions(), this.layout(this.size);
    }
  }, {
    key: "getViewSize",
    value: function getViewSize(e) {
      return e < 0 || e >= this.viewItems.length ? -1 : this.viewItems[e].size;
    }
  }, {
    key: "isViewVisible",
    value: function isViewVisible(e) {
      if (e < 0 || e >= this.viewItems.length) throw new Error("Index out of bounds");
      return this.viewItems[e].visible;
    }
  }, {
    key: "setViewVisible",
    value: function setViewVisible(e, t) {
      if (e < 0 || e >= this.viewItems.length) throw new Error("Index out of bounds");
      this.viewItems[e].setVisible(t), this.distributeEmptySpace(e), this.layoutViews(), this.saveProportions();
    }
  }, {
    key: "distributeViewSizes",
    value: function distributeViewSizes() {
      var _this7 = this;
      var e = [];
      var t = 0;
      var _iterator3 = _createForOfIteratorHelper(this.viewItems),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _i7 = _step3.value;
          _i7.maximumSize - _i7.minimumSize > 0 && (e.push(_i7), t += _i7.size);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var i = Math.floor(t / e.length);
      for (var _i6 = 0, _e7 = e; _i6 < _e7.length; _i6++) {
        var _t6 = _e7[_i6];
        _t6.size = v(i, _t6.minimumSize, _t6.maximumSize);
      }
      var n = R(0, this.viewItems.length),
        s = n.filter(function (e) {
          return _this7.viewItems[e].priority === ze.Low;
        }),
        r = n.filter(function (e) {
          return _this7.viewItems[e].priority === ze.High;
        });
      this.relayout(s, r);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.sashItems.forEach(function (e) {
        return e.sash.dispose();
      }), this.sashItems = [], this.sashContainer.remove();
    }
  }, {
    key: "relayout",
    value: function relayout(e, t) {
      var i = this.viewItems.reduce(function (e, t) {
        return e + t.size;
      }, 0);
      this.resize(this.viewItems.length - 1, this.size - i, void 0, e, t), this.distributeEmptySpace(), this.layoutViews(), this.saveProportions();
    }
  }, {
    key: "onSashStart",
    value: function onSashStart(_ref) {
      var _this8 = this;
      var e = _ref.sash,
        t = _ref.start;
      var i = this.sashItems.findIndex(function (t) {
        return t.sash === e;
      });
      (function (e) {
        var t = _this8.viewItems.map(function (e) {
          return e.size;
        });
        var n,
          s,
          r = Number.NEGATIVE_INFINITY,
          o = Number.POSITIVE_INFINITY;
        var a = R(i, -1, -1),
          u = R(i + 1, _this8.viewItems.length),
          c = a.reduce(function (e, i) {
            return e + (_this8.viewItems[i].minimumSize - t[i]);
          }, 0),
          h = a.reduce(function (e, i) {
            return e + (_this8.viewItems[i].viewMaximumSize - t[i]);
          }, 0),
          l = 0 === u.length ? Number.POSITIVE_INFINITY : u.reduce(function (e, i) {
            return e + (t[i] - _this8.viewItems[i].minimumSize);
          }, 0),
          f = 0 === u.length ? Number.NEGATIVE_INFINITY : u.reduce(function (e, i) {
            return e + (t[i] - _this8.viewItems[i].viewMaximumSize);
          }, 0);
        r = Math.max(c, f), o = Math.min(l, h);
        var m = _this8.findFirstSnapIndex(a),
          d = _this8.findFirstSnapIndex(u);
        if ("number" == typeof m) {
          var _e8 = _this8.viewItems[m],
            _t7 = Math.floor(_e8.viewMinimumSize / 2);
          n = {
            index: m,
            limitDelta: _e8.visible ? r - _t7 : r + _t7,
            size: _e8.size
          };
        }
        if ("number" == typeof d) {
          var _e9 = _this8.viewItems[d],
            _t8 = Math.floor(_e9.viewMinimumSize / 2);
          s = {
            index: d,
            limitDelta: _e9.visible ? o + _t8 : o - _t8,
            size: _e9.size
          };
        }
        _this8.sashDragState = {
          start: e,
          current: e,
          index: i,
          sizes: t,
          minDelta: r,
          maxDelta: o,
          snapBefore: n,
          snapAfter: s
        };
      })(t);
    }
  }, {
    key: "onSashChange",
    value: function onSashChange(_ref2) {
      var e = _ref2.current;
      var _this$sashDragState = this.sashDragState,
        t = _this$sashDragState.index,
        i = _this$sashDragState.start,
        n = _this$sashDragState.sizes,
        s = _this$sashDragState.minDelta,
        r = _this$sashDragState.maxDelta,
        o = _this$sashDragState.snapBefore,
        a = _this$sashDragState.snapAfter;
      this.sashDragState.current = e;
      var u = e - i;
      this.resize(t, u, n, void 0, void 0, s, r, o, a), this.distributeEmptySpace(), this.layoutViews();
    }
  }, {
    key: "getSashPosition",
    value: function getSashPosition(e) {
      var t = 0;
      for (var _i8 = 0; _i8 < this.sashItems.length; _i8++) if (t += this.viewItems[_i8].size, this.sashItems[_i8].sash === e) return t;
      return 0;
    }
  }, {
    key: "resize",
    value: function resize(e, t) {
      var _this9 = this;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.viewItems.map(function (e) {
        return e.size;
      });
      var n = arguments.length > 3 ? arguments[3] : undefined;
      var s = arguments.length > 4 ? arguments[4] : undefined;
      var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Number.NEGATIVE_INFINITY;
      var o = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : Number.POSITIVE_INFINITY;
      var a = arguments.length > 7 ? arguments[7] : undefined;
      var u = arguments.length > 8 ? arguments[8] : undefined;
      if (e < 0 || e >= this.viewItems.length) return 0;
      var c = R(e, -1, -1),
        h = R(e + 1, this.viewItems.length);
      if (s) {
        var _iterator4 = _createForOfIteratorHelper(s),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _e10 = _step4.value;
            F(c, _e10), F(h, _e10);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
      if (n) {
        var _iterator5 = _createForOfIteratorHelper(n),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _e11 = _step5.value;
            k(c, _e11), k(h, _e11);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
      var l = c.map(function (e) {
          return _this9.viewItems[e];
        }),
        f = c.map(function (e) {
          return i[e];
        }),
        m = h.map(function (e) {
          return _this9.viewItems[e];
        }),
        d = h.map(function (e) {
          return i[e];
        }),
        p = c.reduce(function (e, t) {
          return e + (_this9.viewItems[t].minimumSize - i[t]);
        }, 0),
        y = c.reduce(function (e, t) {
          return e + (_this9.viewItems[t].maximumSize - i[t]);
        }, 0),
        b = 0 === h.length ? Number.POSITIVE_INFINITY : h.reduce(function (e, t) {
          return e + (i[t] - _this9.viewItems[t].minimumSize);
        }, 0),
        g = 0 === h.length ? Number.NEGATIVE_INFINITY : h.reduce(function (e, t) {
          return e + (i[t] - _this9.viewItems[t].maximumSize);
        }, 0),
        z = Math.max(p, g, r),
        w = Math.min(b, y, o);
      var S = !1;
      if (a) {
        var _e12 = this.viewItems[a.index],
          _i9 = t >= a.limitDelta;
        S = _i9 !== _e12.visible, _e12.setVisible(_i9, a.size);
      }
      if (!S && u) {
        var _e13 = this.viewItems[u.index],
          _i10 = t < u.limitDelta;
        S = _i10 !== _e13.visible, _e13.setVisible(_i10, u.size);
      }
      if (S) return this.resize(e, t, i, n, s, r, o);
      for (var _e14 = 0, _i11 = t = v(t, z, w); _e14 < l.length; _e14++) {
        var _t9 = l[_e14],
          _n4 = v(f[_e14] + _i11, _t9.minimumSize, _t9.maximumSize);
        _i11 -= _n4 - f[_e14], _t9.size = _n4;
      }
      for (var _e15 = 0, _i12 = t; _e15 < m.length; _e15++) {
        var _t10 = m[_e15],
          _n5 = v(d[_e15] - _i12, _t10.minimumSize, _t10.maximumSize);
        _i12 += _n5 - d[_e15], _t10.size = _n5;
      }
      return t;
    }
  }, {
    key: "distributeEmptySpace",
    value: function distributeEmptySpace(e) {
      var t = this.viewItems.reduce(function (e, t) {
        return e + t.size;
      }, 0);
      var i = this.size - t;
      var n = R(this.viewItems.length - 1, -1, -1);
      "number" == typeof e && k(n, e);
      for (var _e16 = 0; 0 !== i && _e16 < n.length; _e16++) {
        var _t11 = this.viewItems[n[_e16]],
          _s3 = v(_t11.size + i, _t11.minimumSize, _t11.maximumSize);
        i -= _s3 - _t11.size, _t11.size = _s3;
      }
    }
  }, {
    key: "layoutViews",
    value: function layoutViews() {
      var _this$onDidChange;
      this.contentSize = this.viewItems.reduce(function (e, t) {
        return e + t.size;
      }, 0);
      var e = 0;
      var _iterator6 = _createForOfIteratorHelper(this.viewItems),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _t12 = _step6.value;
          _t12.layout(e), e += _t12.size;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      (_this$onDidChange = this.onDidChange) !== null && _this$onDidChange !== void 0 && _this$onDidChange.call(this, this.viewItems.map(function (e) {
        return e.size;
      })), this.sashItems.forEach(function (e) {
        return e.sash.layout();
      }), this.updateSashEnablement();
    }
  }, {
    key: "saveProportions",
    value: function saveProportions() {
      var _this10 = this;
      this.proportionalLayout && this.contentSize > 0 && (this.proportions = this.viewItems.map(function (e) {
        return e.size / _this10.contentSize;
      }));
    }
  }, {
    key: "updateSashEnablement",
    value: function updateSashEnablement() {
      var e = !1;
      var t = this.viewItems.map(function (t) {
        return e = t.size - t.minimumSize > 0 || e;
      });
      e = !1;
      var i = this.viewItems.map(function (t) {
          return e = t.maximumSize - t.size > 0 || e;
        }),
        n = _toConsumableArray(this.viewItems).reverse();
      e = !1;
      var s = n.map(function (t) {
        return e = t.size - t.minimumSize > 0 || e;
      }).reverse();
      e = !1;
      var r = n.map(function (t) {
        return e = t.maximumSize - t.size > 0 || e;
      }).reverse();
      var o = 0;
      for (var _e17 = 0; _e17 < this.sashItems.length; _e17++) {
        var _n6 = this.sashItems[_e17].sash;
        o += this.viewItems[_e17].size;
        var _a = !(t[_e17] && r[_e17 + 1]),
          _u = !(i[_e17] && s[_e17 + 1]);
        if (_a && _u) {
          var _i13 = R(_e17, -1, -1),
            _r = R(_e17 + 1, this.viewItems.length),
            _a2 = this.findFirstSnapIndex(_i13),
            _u2 = this.findFirstSnapIndex(_r),
            _c = "number" == typeof _a2 && !this.viewItems[_a2].visible,
            _h = "number" == typeof _u2 && !this.viewItems[_u2].visible;
          _c && s[_e17] && (o > 0 || this.startSnappingEnabled) ? _n6.state = de.Minimum : _h && t[_e17] && (o < this.contentSize || this.endSnappingEnabled) ? _n6.state = de.Maximum : _n6.state = de.Disabled;
        } else _n6.state = _a && !_u ? de.Minimum : !_a && _u ? de.Maximum : de.Enabled;
      }
    }
  }, {
    key: "findFirstSnapIndex",
    value: function findFirstSnapIndex(e) {
      var _iterator7 = _createForOfIteratorHelper(e),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _t13 = _step7.value;
          var _e18 = this.viewItems[_t13];
          if (_e18.visible && _e18.snap) return _t13;
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      var _iterator8 = _createForOfIteratorHelper(e),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _t14 = _step8.value;
          var _e19 = this.viewItems[_t14];
          if (_e19.visible && _e19.maximumSize - _e19.minimumSize > 0) return;
          if (!_e19.visible && _e19.snap) return _t14;
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }]);
}(T);
var xe = /*#__PURE__*/function () {
  function xe(e) {
    _classCallCheck(this, xe);
    this.size = void 0, this.size = e;
  }
  return _createClass(xe, [{
    key: "getPreferredSize",
    value: function getPreferredSize() {
      return this.size;
    }
  }]);
}();
var Ee = /*#__PURE__*/function () {
  function Ee(e, t) {
    _classCallCheck(this, Ee);
    this.proportion = void 0, this.layoutService = void 0, this.proportion = e, this.layoutService = t;
  }
  return _createClass(Ee, [{
    key: "getPreferredSize",
    value: function getPreferredSize() {
      return this.proportion * this.layoutService.getSize();
    }
  }]);
}();
var Ve = /*#__PURE__*/function () {
  function Ve() {
    _classCallCheck(this, Ve);
  }
  return _createClass(Ve, [{
    key: "getPreferredSize",
    value: function getPreferredSize() {}
  }]);
}();
var je = /*#__PURE__*/function () {
  function je(e, t) {
    var _t$priority;
    _classCallCheck(this, je);
    if (this.minimumSize = 0, this.maximumSize = Number.POSITIVE_INFINITY, this.element = void 0, this.priority = void 0, this.snap = void 0, this.layoutService = void 0, this.layoutStrategy = void 0, this.layoutService = e, this.element = t.element, this.minimumSize = "number" == typeof t.minimumSize ? t.minimumSize : 30, this.maximumSize = "number" == typeof t.maximumSize ? t.maximumSize : Number.POSITIVE_INFINITY, "number" == typeof t.preferredSize) this.layoutStrategy = new xe(t.preferredSize);else if ("string" == typeof t.preferredSize) {
      var _e20 = t.preferredSize.trim();
      if (A(_e20, "%")) {
        var _t15 = Number(_e20.slice(0, -1)) / 100;
        this.layoutStrategy = new Ee(_t15, this.layoutService);
      } else if (A(_e20, "px")) {
        var _t16 = Number(_e20.slice(0, -2));
        this.layoutStrategy = new xe(_t16);
      } else if ("number" == typeof Number.parseFloat(_e20)) {
        var _t17 = Number.parseFloat(_e20);
        this.layoutStrategy = new xe(_t17);
      } else this.layoutStrategy = new Ve();
    } else this.layoutStrategy = new Ve();
    this.priority = (_t$priority = t.priority) !== null && _t$priority !== void 0 ? _t$priority : ze.Normal, this.snap = "boolean" == typeof t.snap && t.snap;
  }
  return _createClass(je, [{
    key: "preferredSize",
    get: function get() {
      return this.layoutStrategy.getPreferredSize();
    },
    set: function set(e) {
      if ("number" == typeof e) this.layoutStrategy = new xe(e);else if ("string" == typeof e) {
        var _t18 = e.trim();
        if (A(_t18, "%")) {
          var _e21 = Number(_t18.slice(0, -1)) / 100;
          this.layoutStrategy = new Ee(_e21, this.layoutService);
        } else if (A(_t18, "px")) {
          var _e22 = Number(_t18.slice(0, -2)) / 100;
          this.layoutStrategy = new xe(_e22);
        } else if ("number" == typeof Number.parseFloat(_t18)) {
          var _e23 = Number.parseFloat(_t18);
          this.layoutStrategy = new xe(_e23);
        } else this.layoutStrategy = new Ve();
      } else this.layoutStrategy = new Ve();
    }
  }, {
    key: "layout",
    value: function layout(e) {}
  }]);
}();
function Le(e) {
  return void 0 !== e.minSize || void 0 !== e.maxSize || void 0 !== e.preferredSize || void 0 !== e.priority || void 0 !== e.visible;
}
var Oe = e.forwardRef(function (_ref3, n) {
  var t = _ref3.className,
    i = _ref3.children;
  return e.createElement("div", {
    ref: n,
    className: r("split-view-view", I, t)
  }, i);
});
Oe.displayName = "Allotment.Pane";
var De = e.forwardRef(function (_ref4, g) {
  var t = _ref4.children,
    i = _ref4.className,
    n = _ref4.id,
    _ref4$maxSize = _ref4.maxSize,
    s = _ref4$maxSize === void 0 ? 1 / 0 : _ref4$maxSize,
    _ref4$minSize = _ref4.minSize,
    o = _ref4$minSize === void 0 ? 30 : _ref4$minSize,
    _ref4$proportionalLay = _ref4.proportionalLayout,
    a = _ref4$proportionalLay === void 0 ? !0 : _ref4$proportionalLay,
    _ref4$separator = _ref4.separator,
    u = _ref4$separator === void 0 ? !0 : _ref4$separator,
    c = _ref4.sizes,
    _ref4$defaultSizes = _ref4.defaultSizes,
    h = _ref4$defaultSizes === void 0 ? c : _ref4$defaultSizes,
    _ref4$snap = _ref4.snap,
    l = _ref4$snap === void 0 ? !1 : _ref4$snap,
    _ref4$vertical = _ref4.vertical,
    f = _ref4$vertical === void 0 ? !1 : _ref4$vertical,
    m = _ref4.onChange,
    d = _ref4.onReset,
    p = _ref4.onVisibleChange,
    v = _ref4.onDragStart,
    y = _ref4.onDragEnd;
  var S = e.useRef(null),
    I = e.useRef([]),
    j = e.useRef(new Map()),
    L = e.useRef(null),
    O = e.useRef(new Map()),
    N = e.useRef(new P()),
    A = e.useRef([]),
    _e$useState = e.useState(!1),
    _e$useState2 = _slicedToArray(_e$useState, 2),
    C = _e$useState2[0],
    T = _e$useState2[1];
  "production" !== process.env.NODE_ENV && c && console.warn("Prop sizes is deprecated. Please use defaultSizes instead.");
  var F = e.useMemo(function () {
      return e.Children.toArray(t).filter(e.isValidElement);
    }, [t]),
    k = e.useCallback(function (e) {
      var _A$current, _L$current;
      var t = (_A$current = A.current) === null || _A$current === void 0 ? void 0 : _A$current[e];
      return "number" == typeof (t === null || t === void 0 ? void 0 : t.preferredSize) && ((_L$current = L.current) !== null && _L$current !== void 0 && _L$current.resizeView(e, Math.round(t.preferredSize)), !0);
    }, []);
  return e.useImperativeHandle(g, function () {
    return {
      reset: function reset() {
        if (d) d();else {
          var _L$current2;
          (_L$current2 = L.current) === null || _L$current2 === void 0 || _L$current2.distributeViewSizes();
          for (var _e24 = 0; _e24 < A.current.length; _e24++) k(_e24);
        }
      },
      resize: function resize(e) {
        var _L$current3;
        (_L$current3 = L.current) === null || _L$current3 === void 0 || _L$current3.resizeViews(e);
      }
    };
  }), M(function () {
    var e = !0;
    h && O.current.size !== h.length && (e = !1, console.warn("Expected ".concat(h.length, " children based on defaultSizes but found ").concat(O.current.size))), e && h && (I.current = F.map(function (e) {
      return e.key;
    }));
    var t = _objectSpread({
      orientation: f ? me.Vertical : me.Horizontal,
      proportionalLayout: a
    }, e && h && {
      descriptor: {
        size: h.reduce(function (e, t) {
          return e + t;
        }, 0),
        views: h.map(function (e, t) {
          var _i$minSize, _i$maxSize, _i$priority, _i$snap;
          var i = j.current.get(I.current[t]),
            n = new je(N.current, _objectSpread(_objectSpread({
              element: document.createElement("div"),
              minimumSize: (_i$minSize = i === null || i === void 0 ? void 0 : i.minSize) !== null && _i$minSize !== void 0 ? _i$minSize : o,
              maximumSize: (_i$maxSize = i === null || i === void 0 ? void 0 : i.maxSize) !== null && _i$maxSize !== void 0 ? _i$maxSize : s,
              priority: (_i$priority = i === null || i === void 0 ? void 0 : i.priority) !== null && _i$priority !== void 0 ? _i$priority : ze.Normal
            }, (i === null || i === void 0 ? void 0 : i.preferredSize) && {
              preferredSize: i === null || i === void 0 ? void 0 : i.preferredSize
            }), {}, {
              snap: (_i$snap = i === null || i === void 0 ? void 0 : i.snap) !== null && _i$snap !== void 0 ? _i$snap : l
            }));
          return A.current.push(n), {
            container: _toConsumableArray(O.current.values())[t],
            size: e,
            view: n
          };
        })
      }
    });
    L.current = new Ie(S.current, t, m, v, y), L.current.on("sashDragStart", function () {
      var _S$current;
      (_S$current = S.current) === null || _S$current === void 0 || _S$current.classList.add("split-view-sash-dragging");
    }), L.current.on("sashDragEnd", function () {
      var _S$current2;
      (_S$current2 = S.current) === null || _S$current2 === void 0 || _S$current2.classList.remove("split-view-sash-dragging");
    }), L.current.on("sashchange", function (e) {
      if (p && L.current) {
        var _e25 = F.map(function (e) {
          return e.key;
        });
        for (var _t19 = 0; _t19 < _e25.length; _t19++) {
          var _i14 = j.current.get(_e25[_t19]);
          void 0 !== (_i14 === null || _i14 === void 0 ? void 0 : _i14.visible) && _i14.visible !== L.current.isViewVisible(_t19) && p(_t19, L.current.isViewVisible(_t19));
        }
      }
    }), L.current.on("sashreset", function (e) {
      if (d) d();else {
        var _L$current4;
        if (k(e)) return;
        if (k(e + 1)) return;
        (_L$current4 = L.current) === null || _L$current4 === void 0 || _L$current4.distributeViewSizes();
      }
    });
    var i = L.current;
    return function () {
      i.dispose();
    };
  }, []), M(function () {
    if (C) {
      var _e26 = F.map(function (e) {
          return e.key;
        }),
        _t20 = _toConsumableArray(I.current),
        _i15 = _e26.filter(function (e) {
          return !I.current.includes(e);
        }),
        _n7 = _e26.filter(function (e) {
          return I.current.includes(e);
        }),
        _r2 = I.current.map(function (t) {
          return !_e26.includes(t);
        });
      for (var _e27 = _r2.length - 1; _e27 >= 0; _e27--) {
        var _L$current5;
        _r2[_e27] && ((_L$current5 = L.current) !== null && _L$current5 !== void 0 && _L$current5.removeView(_e27), _t20.splice(_e27, 1), A.current.splice(_e27, 1));
      }
      var _iterator9 = _createForOfIteratorHelper(_i15),
        _step9;
      try {
        var _loop3 = function _loop3() {
          var _i$minSize2, _i$maxSize2, _i$priority2, _i$snap2, _L$current9;
          var n = _step9.value;
          var i = j.current.get(n),
            r = new je(N.current, _objectSpread(_objectSpread({
              element: document.createElement("div"),
              minimumSize: (_i$minSize2 = i === null || i === void 0 ? void 0 : i.minSize) !== null && _i$minSize2 !== void 0 ? _i$minSize2 : o,
              maximumSize: (_i$maxSize2 = i === null || i === void 0 ? void 0 : i.maxSize) !== null && _i$maxSize2 !== void 0 ? _i$maxSize2 : s,
              priority: (_i$priority2 = i === null || i === void 0 ? void 0 : i.priority) !== null && _i$priority2 !== void 0 ? _i$priority2 : ze.Normal
            }, (i === null || i === void 0 ? void 0 : i.preferredSize) && {
              preferredSize: i === null || i === void 0 ? void 0 : i.preferredSize
            }), {}, {
              snap: (_i$snap2 = i === null || i === void 0 ? void 0 : i.snap) !== null && _i$snap2 !== void 0 ? _i$snap2 : l
            }));
          (_L$current9 = L.current) !== null && _L$current9 !== void 0 && _L$current9.addView(O.current.get(n), r, be.Distribute, _e26.findIndex(function (e) {
            return e === n;
          })), _t20.splice(_e26.findIndex(function (e) {
            return e === n;
          }), 0, n), A.current.splice(_e26.findIndex(function (e) {
            return e === n;
          }), 0, r);
        };
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          _loop3();
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      for (; !b(_e26, _t20);) {
        var _iterator10 = _createForOfIteratorHelper(_e26.entries()),
          _step10;
        try {
          var _loop = function _loop() {
            var _step10$value = _slicedToArray(_step10.value, 2),
              i = _step10$value[0],
              n = _step10$value[1];
            var e = _t20.findIndex(function (e) {
              return e === n;
            });
            if (e !== i) {
              var _L$current6;
              (_L$current6 = L.current) === null || _L$current6 === void 0 || _L$current6.moveView(O.current.get(n), e, i);
              var _s4 = _t20[e];
              _t20.splice(e, 1), _t20.splice(i, 0, _s4);
              return 1; // break
            }
          };
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            if (_loop()) break;
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }
      var _iterator11 = _createForOfIteratorHelper(_i15),
        _step11;
      try {
        var _loop4 = function _loop4() {
          var _L$current10;
          var t = _step11.value;
          var i = _e26.findIndex(function (e) {
              return e === t;
            }),
            n = A.current[i].preferredSize;
          void 0 !== n && ((_L$current10 = L.current) === null || _L$current10 === void 0 ? void 0 : _L$current10.resizeView(i, n));
        };
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          _loop4();
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      var _loop2 = function _loop2() {
        var _L$current7, _L$current8;
        var t = _arr[_i16];
        var i = j.current.get(t),
          n = _e26.findIndex(function (e) {
            return e === t;
          });
        i && Le(i) && void 0 !== i.visible && ((_L$current7 = L.current) === null || _L$current7 === void 0 ? void 0 : _L$current7.isViewVisible(n)) !== i.visible && ((_L$current8 = L.current) === null || _L$current8 === void 0 ? void 0 : _L$current8.setViewVisible(n, i.visible));
      };
      for (var _i16 = 0, _arr = [].concat(_toConsumableArray(_i15), _toConsumableArray(_n7)); _i16 < _arr.length; _i16++) {
        _loop2();
      }
      var _iterator12 = _createForOfIteratorHelper(_n7),
        _step12;
      try {
        var _loop5 = function _loop5() {
          var t = _step12.value;
          var i = j.current.get(t),
            n = _e26.findIndex(function (e) {
              return e === t;
            });
          if (i && Le(i)) {
            var _L$current11;
            void 0 !== i.preferredSize && A.current[n].preferredSize !== i.preferredSize && (A.current[n].preferredSize = i.preferredSize);
            var _e28 = !1;
            void 0 !== i.minSize && A.current[n].minimumSize !== i.minSize && (A.current[n].minimumSize = i.minSize, _e28 = !0), void 0 !== i.maxSize && A.current[n].maximumSize !== i.maxSize && (A.current[n].maximumSize = i.maxSize, _e28 = !0), _e28 && ((_L$current11 = L.current) === null || _L$current11 === void 0 ? void 0 : _L$current11.layout());
          }
        };
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          _loop5();
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      (_i15.length > 0 || _r2.length > 0) && (I.current = _e26);
    }
  }, [F, C, s, o, l]), e.useEffect(function () {
    L.current && (L.current.onDidChange = m);
  }, [m]), e.useEffect(function () {
    L.current && (L.current.onDidDragStart = v);
  }, [v]), e.useEffect(function () {
    L.current && (L.current.onDidDragEnd = y);
  }, [y]), z({
    ref: S,
    onResize: function onResize(_ref5) {
      var _L$current12;
      var e = _ref5.width,
        t = _ref5.height;
      e && t && ((_L$current12 = L.current) !== null && _L$current12 !== void 0 && _L$current12.layout(f ? t : e), N.current.setSize(f ? t : e), T(!0));
    }
  }), e.useEffect(function () {
    D && Ne(20);
  }, []), e.createElement("div", {
    ref: S,
    className: r("split-view", f ? "split-view-vertical" : "split-view-horizontal", {
      "split-view-separator-border": u
    }, w, f ? x : E, _defineProperty({}, V, u), i),
    id: n
  }, e.createElement("div", {
    className: r("split-view-container", _)
  }, e.Children.toArray(t).map(function (t) {
    if (!e.isValidElement(t)) return null;
    var i = t.key;
    return "Allotment.Pane" === t.type.displayName ? (j.current.set(i, t.props), e.cloneElement(t, {
      key: i,
      ref: function ref(e) {
        var n = t.ref;
        n && (n.current = e), e ? O.current.set(i, e) : O.current["delete"](i);
      }
    })) : e.createElement(Oe, {
      key: i,
      ref: function ref(e) {
        e ? O.current.set(i, e) : O.current["delete"](i);
      }
    }, t);
  })));
});
function Ne(e) {
  var t = v(e, 4, 20),
    i = v(e, 1, 8);
  document.documentElement.style.setProperty("--sash-size", t + "px"), document.documentElement.style.setProperty("--sash-hover-size", i + "px"), function (e) {
    pe = e, ve.emit("onDidChangeGlobalSize", e);
  }(t);
}
De.displayName = "Allotment";
var Me = Object.assign(De, {
  Pane: Oe
});
exports.Allotment = Me, exports.LayoutPriority = ze, exports.setSashSize = Ne;
